const defaultOptions = { errorMessage: 'Required' };
const validateInput = (input = '', options = defaultOptions) => {
    const opts = Object.assign(Object.assign({}, defaultOptions), options);
    const stringInput = input || '';
    return !(stringInput === null || stringInput === void 0 ? void 0 : stringInput.trim()) ? opts.errorMessage : undefined;
};
export const validateRequired = (input) => validateInput(input);
export const getValidateRequiredFn = (options) => {
    return (input) => validateInput(input, options);
};
